import { render, staticRenderFns } from "./PolicyTypes.vue?vue&type=template&id=1d059311&scoped=true"
import script from "./PolicyTypes.vue?vue&type=script&lang=js"
export * from "./PolicyTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d059311",
  null
  
)

export default component.exports